import { render } from "./PythonTong.vue?vue&type=template&id=98fc0eae&scoped=true"
import script from "./PythonTong.vue?vue&type=script&lang=js"
export * from "./PythonTong.vue?vue&type=script&lang=js"

import "./PythonTong.vue?vue&type=style&index=0&id=98fc0eae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98fc0eae"]])

export default __exports__